export enum Routes {
  Home = '/',
  Contact = '/contact',
  Faq = '/faq',
  Community = '/community',
}
